// frontend/packages/business-console/src/components/media/RecentlyUsedRow.jsx

import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, Chip } from "@mui/material";
import { listRecentlyUsed } from "../../services/mediaService";

export default function RecentlyUsedRow({ onSelect }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const data = await listRecentlyUsed(10);
        if (!alive) return;
        setItems(Array.isArray(data) ? data : []);
      } catch {
        if (!alive) return;
        setItems([]);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (!items.length) return null;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 1 }}>
        Recently used
      </Typography>
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
        {items.map((it) => {
          const label = it?.title || it?.name || (it?.blobPath ? it.blobPath.split("/").pop() : "Asset");
          return (
            <Chip
              key={it?.id || it?._id || it?.providerPublicId || label}
              label={label}
              onClick={() => onSelect?.(it)}
              sx={{ fontWeight: 700 }}
            />
          );
        })}
      </Stack>
    </Box>
  );
}